// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__20w9Y","title":"ClientCherryInfo_title__1eyXS","itemText":"ClientCherryInfo_itemText__3EXda"};